// -----------------------------------------------------------------Imports---
import { getAppApiRoutes } from "../../Global";
import {
  BaseListRequestModel,
  PartnerAddRequestModel,
  PartnerFilterRequestModel,
  PartnerUpdateRequestModel,
} from "../../models/RequestModels";
import ResponseModel from "../../models/ResponseModel";
import { apiDelete, apiGet, apiPost, apiPut } from "../apiClient";

// ----------------------------------------------------------------Privates---
class PartnerService {
  async getPartners(data: BaseListRequestModel<PartnerFilterRequestModel> = {}): Promise<ResponseModel> {
    return apiPost(getAppApiRoutes.partner.getPartners, data);
  }

  async updatePartner(
    partner: PartnerUpdateRequestModel | Record<string, unknown>,
    id: string,
  ): Promise<ResponseModel> {
    return apiPut(getAppApiRoutes.partner.updatePartner.replace("{id}", id), { ...partner });
  }

  async getPartner(id: string): Promise<ResponseModel> {
    return apiGet(getAppApiRoutes.partner.getPartner.replace("{id}", id));
  }

  async deletePartner(id: number): Promise<ResponseModel> {
    return apiDelete(getAppApiRoutes.partner.removePartner.replace("{id}", id.toString()));
  }

  async addPartner(partner: PartnerAddRequestModel | Record<string, unknown>): Promise<ResponseModel> {
    return apiPost(getAppApiRoutes.partner.addPartner, partner as Record<string, unknown>);
  }
}

// -----------------------------------------------------------------Exports---
const service: PartnerService = new PartnerService();
export default service;
